import { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

interface SVGRProps {
  size?: keyof typeof unitMapping;
  className?: string;
  gradient?: 'green' | 'red';
}

export const UserXMark = ({
  size = 2,
  className,
  gradient,
}: SVGProps<SVGSVGElement> & SVGRProps) => {
  let fill = 'currentColor';
  if (gradient) {
    fill = `url(#${gradient}-gradient)`;
  }

  return (
    <svg
      viewBox="0 0 31 31"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9627 6.15368C11.9627 4.92536 12.9584 3.92961 14.1868 3.92961C15.4151 3.92961 16.4108 4.92536 16.4108 6.15368C16.4108 7.382 15.4151 8.37775 14.1868 8.37775C12.9584 8.37775 11.9627 7.382 11.9627 6.15368ZM14.1868 0.371094C10.9931 0.371094 8.40417 2.96005 8.40417 6.15368C8.40417 8.21311 9.48075 10.0211 11.1018 11.0455H10.628C7.68003 11.0455 5.29023 13.4353 5.29023 16.3833V30.6174H8.84874V16.3833C8.84874 15.4006 9.64534 14.604 10.628 14.604H17.745C18.7277 14.604 19.5243 15.4006 19.5243 16.3833H23.0828C23.0828 13.4353 20.693 11.0455 17.745 11.0455H17.2717C18.8928 10.0211 19.9693 8.21311 19.9693 6.15368C19.9693 2.96005 17.3804 0.371094 14.1868 0.371094ZM23.8193 25.2803L26.336 22.7636L23.8198 20.2473L21.303 22.764L18.7871 20.2481L16.2708 22.7643L18.7868 25.2803L16.271 27.7961L18.7873 30.3123L21.303 27.7965L23.8196 30.3131L26.3358 27.7968L23.8193 25.2803Z"
        fill={fill}
      />
      <defs>
        <linearGradient
          id="green-gradient"
          x1="18.3206"
          y1="35.7766"
          x2="7.76238"
          y2="18.8035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1FF00" />
          <stop offset="1" stopColor="#3DDC84" />
        </linearGradient>
        <linearGradient
          id="red-gradient"
          x1="18.1249"
          y1="35.9728"
          x2="7.46515"
          y2="18.9341"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1FF00" />
          <stop offset="1" stopColor="#FF0974" />
        </linearGradient>
      </defs>
    </svg>
  );
};
